import * as React from 'react';
import { View, StyleSheet, Image, Dimensions } from 'react-native';
import { HEREMap } from 'here-maps-react';
import theme from '../../constants/theme.style.js';

const turtleIcon = require('../../assets/Turtles/main-turtle.png');

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.GREEN_DARKER_COLOR,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    padding: 10,
    marginBottom: 40,
  },
  mapContainer: {
    flex: 1,
    width: windowWidth / 2.5,
    height: windowHeight / 3,
    justifyContent: 'center',
    position: 'relative',
  },
  map: {
    flex: 1,
  },
  turtle: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    width: 70,
    height: 50,
  },
});

export const LocationMap = ({ latitude, longitude }) => {
  const lat = latitude || 47.808512;
  const lng = longitude || 13.0449408;

  return (
    <View style={styles.container}>
      <View style={styles.mapContainer}>
        <HEREMap
          appId="0GqHoDiisFv5I7i0Q6ec"
          apikey="asfsgtwVaioE6nDW7aPw6egFrtsEtOE_osdsSEeh-LU"
          testID="heremap"
          center={{ lat, lng }}
          interactive={false}
          zoom={12}
          style={styles.map}
        />
        <Image style={styles.turtle} source={turtleIcon} />
      </View>
    </View>
  );
};
